<template functional>
  <div>
    <div v-for="(o, index) in props.item.customers" :key="index">
      {{ o.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "fltl-customers",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
